import React, { useState } from 'react';
import t from '~t';

import { Confirm } from '~co/overlay/dialog';
import Blank from './blank';
import View from './view';
import Rename from './rename';
import Contextmenu from './contextmenu';

import DropBookmarks from '~co/bookmarks/dnd/drop';
import Sharing from '../sharing';
import ChangeIcon from '../changeIcon';
import OpenAllBookmarks from '~co/bookmarks/openAll';

function CollectionsItem({
  item = {},
  active = false,
  multiselect = false,
  events = {}, //same as ...items/index
  actions = {}, //redux collections
  ...props
}) {
  const [rename, setRename] = useState(false);
  const [menu, setMenu] = useState(false);
  const [sharing, setSharing] = useState(false);
  const [icon, setIcon] = useState(false);
  const [openAll, setOpenAll] = useState(false);

  const onSelectClick = () => {
    if (active && multiselect) actions.unselectOne(item._id);
    else actions.selectOne(item._id);
  };

  const onExpandClick = () => actions.oneToggle(item._id);

  const onRenameClick = () => {
    if (
      !multiselect &&
      item._id > 0 &&
      item.access &&
      item.access.level >= 3
    )
      setRename(true);
  };

  const onRenameCancel = () => setRename(false);

  const onRemoveClick = async () => {
    if (
      (!item.count && !props.expandable) ||
      (await Confirm(t.s('areYouSure'), {
        variant: 'warning',
        description:
          item._id != -99 ? t.s('collectionDeleteConfirm') : '',
        ok:
          item._id != -99
            ? t.s('remove') + ' ' + item.title
            : t.s('emptyTrash'),
      }))
    )
      actions.oneRemove(item._id);
  };

  const onContextMenu = (e) => {
    e.preventDefault();
    e.target.focus();

    if (!multiselect) setMenu(true);
  };

  const handlers = {
    onClick: (e) => {
      //create new
      if (item._id == -100) {
        e.preventDefault();
        return actions.oneCreate({ title: item.title }, events.onItemClick);
      }

      //select
      if (item._id > 0)
        if (multiselect || e.shiftKey) {
          e.preventDefault();
          return onSelectClick();
        }

      //click on item
      if (events.onItemClick) {
        if (events.onItemClick(item) != 'continue') e.preventDefault();
        else return;
      }

      //otherwise usual click on href
    },

    onOpenAllClick: () => setOpenAll(true),
    opOpenAllClose: () => setOpenAll(false),

    onSelectClick,
    onExpandClick,
    onRenameClick,
    onRenameCancel,

    onIconClick: () => setIcon(true),
    onIconClose: () => setIcon(false),

    onRemoveClick,
    onContextMenu,
    onContextMenuClose: () => setMenu(false),

    onSharing: () => setSharing(true),
    onSharingClose: () => setSharing(false),

    onCreateNewChildClick: async () => {
      actions.addBlank(item._id, true);
    },

    onKeyUp: (e) => {
      if (multiselect) return;

      switch (e.keyCode) {
        case 37: //left
        case 39: //right
          e.preventDefault();
          return onExpandClick();

        case 46: //delete
        case 8: //backspace
          e.preventDefault();
          return onRemoveClick();

        case 13: //enter
          e.preventDefault();

          if (active) return onRenameClick();
          else return e.currentTarget.click();
      }
    },
  };

  const Component =
    item._id == -101 ? Blank : rename ? Rename : View;

  const to = `/my/${item._id}`;

  return (
    <>
      <DropBookmarks spaceId={item._id}>
        {(drop) => (
          <Component
            {...item}
            {...props}
            {...drop}
            isDropping={props.isDropping || drop.isDropping}
            {...handlers}
            to={to}
            active={active}
            multiselect={multiselect}
            events={events}
            actions={actions}
          />
        )}
      </DropBookmarks>

      {menu ? (
        <Contextmenu {...item} {...props} {...handlers} to={to} />
      ) : null}

      {sharing ? (
        <Sharing _id={item._id} onClose={handlers.onSharingClose} />
      ) : null}

      {icon ? (
        <ChangeIcon _id={item._id} onClose={handlers.onIconClose} />
      ) : null}

      {openAll ? (
        <OpenAllBookmarks
          spaceId={item._id}
          onClose={handlers.opOpenAllClose}
        />
      ) : null}
    </>
  );
}

export default React.memo(CollectionsItem);
